module.exports = __webpack_public_path__ + "Montserrat-Regular-080422d4c1328f3407818d25c86cce51.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/montserrat/Montserrat-Regular.woff2
// module id = 872
// module chunks = 86